import React from "react";
import moment from "moment";
import numeral from "numeral";

import Slider, { Range, Handle } from "rc-slider";

import ResponsiveChart from "components/RunPlot/ResponsiveChart";

import { AutoSizer } from "react-virtualized";

import { FORECAST_DEFAULT_GRAPH_DISPLAY } from "containers/Run/reducer";

import {
  LineChart,
  Line,
  Scatter,
  CartesianGrid,
  ComposedChart,
  Area,
  CartesianAxis,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  ZAxis,
  ReferenceLine,
  ReferenceDot,
  ReferenceArea,
  ResponsiveContainer,
  ErrorBar,
  Label,
  Cell,
  LabelList
} from "recharts";

import styles from "./style.module.css";

const DEFAULT_MODELS_SHOW = 12;

const TooltipRangeSlider = Slider.createSliderWithTooltip(Range);

export default class DateRangeSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      updateDelayPointer: undefined,
      dateRangeIndices: props.forecastChartDateRange ? props.forecastChartDateRange : [0, 0]
    };
  }

  handleSliderUpdate(range) {
    const { updateForecastChartDateRange } = this.props;
    if (!range || range.some((e) => !isFinite(e) || e < 0)) {
      return;
    }

    let updateDelayPointer = this.state.updateDelayPointer;

    if (updateDelayPointer !== undefined) {
      clearTimeout(updateDelayPointer);
    }

    updateDelayPointer = setTimeout(() => updateForecastChartDateRange(range), 1000);

    this.setState({ dateRangeIndices: range, updateDelayPointer });
  }

  componentDidUpdate(prevProps) {
    const { forecastPredictionPlot, updateForecastChartDateRange } = this.props;
    if (forecastPredictionPlot?.length > prevProps?.forecastPredictionPlot?.length) {
      this.setState({
        dateRangeIndices: [0, forecastPredictionPlot?.length]
      });
    }
  }

  render() {
    const { id, projectId, forecastPredictionPlot } = this.props;
    const { dateRangeIndices } = this.state;

    if (!forecastPredictionPlot) {
      return <React.Fragment />;
    }

    // this range can be [0, -1], but that allows the handleSliderUpdate to catch an unwanted
    // update when forecastPredictionPlot has no entries. Double check the graph behavior
    // as models roll in and a new model is automatically selected if you update this.
    const sliderRange = [0, forecastPredictionPlot ? forecastPredictionPlot.length - 1 : 0];

    return (
      <div className={styles.dateRangeSelectWrapper}>
        <div className={styles.dateRangeSelectLabel}>{"Chart Focus"}</div>
        <div className={styles.dateRangeSelect}>
          <div className={styles.dateRangeSelectGraph}>
            <AutoSizer>
              {({ width, height }) => (
                <ComposedChart
                  width={width}
                  height={height}
                  data={forecastPredictionPlot}
                  margin={{
                    top: 0,
                    right: -2,
                    left: -2,
                    bottom: 0
                  }}
                  syncId="forecastCharts"
                >
                  <XAxis hide dataKey="Date"></XAxis>
                  <YAxis type="number" domain={["auto", "auto"]} hide></YAxis>
                  <Line dataKey="Actual" dot={false} stroke="#868595" strokeWidth={1} />
                  <Line
                    type="monotone"
                    dataKey="Prediction"
                    dot={false}
                    stroke="#868595"
                    strokeWidth={1}
                    strokeDasharray="5 4"
                  />
                </ComposedChart>
              )}
            </AutoSizer>
          </div>
          <div className={styles.dateRangeSelectSlider}>
            <TooltipRangeSlider
              min={sliderRange[0]}
              max={sliderRange[1]}
              onChange={(e) => this.handleSliderUpdate(e)}
              value={dateRangeIndices}
              step={1}
              railStyle={{ backgroundColor: "transparent", height: 50 }}
              trackStyle={[{ backgroundColor: "#7E69D755", height: 50, borderRadius: 0 }]}
              className={styles.dateRangeSelectSliderActual}
              handleStyle={{
                height: 50,
                width: 7,
                borderColor: "#FFFFFF",
                borderWidth: 0,
                borderRadius: 2,
                backgroundColor: "#7E69D7",
                marginTop: 0,
                marginLeft: 0,
                zIndex: 100
              }}
              tipFormatter={(value) => {
                return (
                  <div className={styles.forecastSliderTooltip}>
                    {forecastPredictionPlot && forecastPredictionPlot[value] ? forecastPredictionPlot[value].Date : ""}
                  </div>
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
